import { Boton, Centro, PilaV } from '@/components/atomos';
import { CREDENCIALES } from '@/routes/AppRoutes';
import { Heading } from '@chakra-ui/react';
import { ChevronLeft, ServerCrash } from 'lucide-react';
import { Link } from 'react-router-dom';

const ErrorVerificacion = () => {
  return (
    <Centro h={'100dvh'} flexDir={'column'} gap={4}>
      <PilaV spacing={0}>
        <ServerCrash size={150} strokeWidth={1} color='var(--compo-500)' />
        <Heading color={'compo.500'} size={'lg'} fontWeight={'medium'}>
          Link invalido o expirado
        </Heading>
      </PilaV>
      <Boton as={Link} to={CREDENCIALES.INICIARSESION} variant={'action'}
            justifyContent={'center'}>
        Volver al inicio
      </Boton>
    </Centro>
  );
};

export default ErrorVerificacion;
